import { noop } from 'lodash/fp';
import { NormalizedCacheObject } from '@apollo/client';
import type { compose } from 'redux';

const serverStub = {
  Trustpilot: undefined,
  __APOLLO_STATE__: undefined,
  __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: undefined,
  __config: undefined,
  __productReviewSettings: {},
  activeElement: null,
  addEventListener: noop,
  body: {
    appendChild: noop,
    removeChild: noop,
    style: {
      overflow: '',
    },
  },
  cookie: '',
  createElement: noop,
  getElementById: noop,
  gtag: noop,
  location: {},
  querySelector: noop,
  removeEventListener: noop,
  scrollTo: noop,
  sessionStorage: {
    getItem: () => null,
    removeItem: () => null,
    setItem: () => null,
  },
  supports: noop,
};

function getDocument(): Document | typeof serverStub {
  if (typeof window !== 'undefined') {
    return document;
  }
  return serverStub;
}

type WindowType = Window & {
  Trustpilot?: {
    loadFromElement: (element: HTMLElement, reload: boolean) => void;
  };
  __APOLLO_STATE__?: NormalizedCacheObject;
  __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: (options?: { trace?: boolean }) => typeof compose;
  gtag: (command: string, ...args: unknown[]) => void;
  // TODO: AEN-94 add types to config
  __config?: any;
};

function getWindow(): WindowType | typeof serverStub {
  if (typeof window !== 'undefined') {
    return window as unknown as WindowType;
  }
  return serverStub;
}

function getCss() {
  if (typeof window !== 'undefined') {
    return CSS;
  }
  return serverStub;
}

export default {
  getCss,
  getDocument,
  getWindow,
};
